package com.parmartechnologies.commerce.feature.invoice.network

import com.parmartechnologies.core.feature.invoice.event.InvoiceEvent
import com.parmartechnologies.core.feature.invoice.network.RetrieveInvoiceRequest
import com.parmartechnologies.core.feature.invoice.network.RetrieveInvoiceResponse
import com.parmartechnologies.core.feature.invoice.network.RetrieveSingleInvoiceRequest
import com.parmartechnologies.core.feature.invoice.network.RetrieveSingleInvoiceResponse
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.client.statement.bodyAsText
import io.ktor.http.ContentType
import io.ktor.http.contentType
import kotlinx.serialization.json.Json
import com.parmartechnologies.core.network.rest.FriendlyClient
import com.parmartechnologies.core.constant.AppServer
import io.ktor.http.HttpHeaders.Server

class InvoiceNetwork {
    val json = Json {
        encodeDefaults = true
        ignoreUnknownKeys = true
    }

    suspend fun retrieve(
        request: RetrieveInvoiceRequest,
        onResult: (RetrieveInvoiceResponse?) -> Unit
    ) {
        val apiRoute = AppServer.shared().getRestApiEndPointFor(InvoiceEvent.api,InvoiceEvent.RETRIEVE)
        try {
            val response = FriendlyClient.post(apiRoute) {
                contentType(ContentType.Application.Json)
                setBody(request)
            }
            onResult(json.decodeFromString(response.bodyAsText()))
        } catch (t: Throwable) {
            print(t)
            onResult(null)
        }
    }

    suspend fun retrieveInvoice(
        request: RetrieveInvoiceRequest,
        onResult: (RetrieveInvoiceResponse?,response: String?) -> Unit
    ) {
        val apiRoute = AppServer.shared().getRestApiEndPointFor(InvoiceEvent.api,InvoiceEvent.RETRIEVE)
        try {
            val response = FriendlyClient.post(apiRoute) {
                contentType(ContentType.Application.Json)
                setBody(request)
            }
            onResult(json.decodeFromString(response.bodyAsText()),response.bodyAsText())
        } catch (t: Throwable) {
            print(t)
            onResult(null,t.message + apiRoute)
        }
    }

    suspend fun retrieveSingle(
        request: RetrieveSingleInvoiceRequest,
        onResult: (RetrieveSingleInvoiceResponse?) -> Unit
    ) {
        val apiRoute = AppServer.shared().getRestApiEndPointFor(InvoiceEvent.api,InvoiceEvent.RETRIVE_SINGLE_INVOICE)
        try {
            val response = FriendlyClient.post(apiRoute) {
                contentType(ContentType.Application.Json)
                setBody(request)
            }
            onResult(json.decodeFromString(response.bodyAsText()))
        } catch (t: Throwable) {
            print(t)
            onResult(null)
        }
    }
}